export const Audio = ({ size = 32 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 33 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Frame 928903">
      <path
        id="Vector 593"
        d="M1.22399 14.4725H31.7759C26.6839 14.4725 24.5622 27.0527 18.6216 27.0527C12.6809 27.0527 10.9836 14.4725 1.22399 14.4725Z"
        fill="url(#paint0_linear_2727_26731)"
      />
      <path
        id="Vector 592"
        d="M1.22399 14.474H31.7759C18.6216 14.474 18.1973 24.3584 12.2566 24.3584C8.0133 24.3584 5.89164 14.474 1.22399 14.474Z"
        fill="url(#paint1_linear_2727_26731)"
      />
      <path
        id="Vector 594"
        d="M0.824957 14.472H32.175C18.6771 14.472 15.5833 8.08008 9.48746 8.08008C5.1333 8.08008 3.71246 14.472 0.824957 14.472Z"
        fill="url(#paint2_linear_2727_26731)"
      />
      <path
        id="Vector 591"
        d="M1.22399 14.4731H31.7759C22.4406 14.4731 20.7433 0.0957031 16.4999 0.0957031C12.2566 0.0957031 11.408 14.4731 1.22399 14.4731Z"
        fill="url(#paint3_linear_2727_26731)"
        fillOpacity="0.86"
      />
      <path
        id="Vector 590"
        d="M32.175 14.472H0.824951C14.3229 14.472 17.4166 8.08008 23.5125 8.08008C27.8666 8.08008 29.2875 14.472 32.175 14.472Z"
        fill="url(#paint4_linear_2727_26731)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2727_26731"
        x1="31.7759"
        y1="20.7626"
        x2="1.22399"
        y2="20.7626"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E182" />
        <stop offset="1" stopColor="#005ECD" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2727_26731"
        x1="19.7159"
        y1="19.4162"
        x2="6.04797"
        y2="19.4162"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD706" stopOpacity="0.84" />
        <stop offset="1" stopColor="#00B212" stopOpacity="0.83" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2727_26731"
        x1="12.375"
        y1="11.2669"
        x2="0.824956"
        y2="11.2669"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF8E09" />
        <stop offset="1" stopColor="#DE0000" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2727_26731"
        x1="24.5399"
        y1="1.47977"
        x2="8.30799"
        y2="11.8007"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B900D7" />
        <stop offset="1" stopColor="#FFD704" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2727_26731"
        x1="16.9125"
        y1="11.2669"
        x2="30.9375"
        y2="11.2669"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF8E09" />
        <stop offset="1" stopColor="#0016DE" />
      </linearGradient>
    </defs>
  </svg>
)
